export const LOGIN_ERRORS: Record<string, string> = {
  INVALID_MOBILE_NUMBER: 'شماره موبایل نامعتبر است!',
  RATE_LIMIT_SEND_OTP_CODE: 'سقف محدودیت ارسال پیامک!',
  NOT_FOUND_MOBILE_NUMBER: 'شماره موبایل یافت نشد!',
  INVALID_OTP_CODE: 'کد واردشده اشتباه است!',
  USER_INCOMPLETE_INFO: 'اطلاعات کاربر ناکافی است!',
  UNAUTHORIZED_API_SERVICE: 'درخواست غیرمجاز است!',
  OPERATION_FAILED: 'خطایی رخ داده است!',
  CAN_NOT_SEND_SMS: 'عدم امکان ارسال پیامک!',
  NOT_FOUND_OTP_MOBILE_NUMBER: 'کد واردشده نامربوط است!',
  USER_IS_DISALLOWED: 'کاربر غیرفعال است!',
  PASSWORD_INCORRECT: 'رمز عبور اشتباه است!',
  USER_NOT_FOUND: 'کاربر یافت نشد!',
  INVALID_USERNAME: 'نام کاربری اشتباه است!',
  INVALID_REFRESH_TOKEN: 'توکن بازیابی نامعتبر است!',
  INVALID_TOKEN: 'توکن نامعتبر است!',
  INVALID_SID_CLAIM: 'شناسه نشست نامعتبر است!',
  DUPLICATE_LOGIN: 'ورود مکرر اتفاق افتاده است!',
  REFRESH_TOKEN_EXPIRED: 'اعتبار توکن پایان یافته است!',
  INACTIVE_USER: 'کاربر غیرفعال است!',
  NOT_FOUND_ACCESS_TOKEN: 'توکن یافت نشد!',
};
